import { Menu, MenuItem, SvgIcon, Tooltip, useTheme } from "@mui/material";
import { t } from "i18next";
import Q3DIconButton from "../../Parts/Q3DIconButton";
import { useContext, useEffect, useState } from "react";
import {
  toolBoxIcon_1,
  BLACK,
  toolBoxIcon_2,
  WHITE,
  toolBoxIcon_3,
} from "../../config/componentsConfig";
import { DETAIL_TAB, ProjectDetailContext } from "../../../pages/ProjectDetail";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import RouteIcon from "@mui/icons-material/Route";
import ToolIcon from "../../../components/Icon";
import CoordinateIcon from "../../../../images/icons/neutral_edit/Coordinate.svg";
import ImageViewerDialog from "../../PhotoshotDialog";
import { config } from "../../../config/config";
import { Common } from "../../../../common/src";

type Props = { projectDetail: Common.ProjectDetail };

export const ShowToolMenu = (props: Props) => {
  const theme = useTheme();

  const [visibilityAnchorEl, setVisibilityAnchorEl] = useState<Element>(null); // menu anchor
  const [showAxis, setShowAxis] = useState<boolean>(true); // axis
  const [showPointCloud, setShowPointCloud] = useState<boolean>(true); // pointCloud
  const [showPhotoshot, setShowPhotoshot] = useState<boolean>(true); // photoshot
  const openVisibilityMenu = (event: any) => {
    setVisibilityAnchorEl(event.currentTarget);
  };
  const { viewer, openProjectState, setOpenProjectState, detailTab } =
    useContext(ProjectDetailContext);
  const btnSize = "36px";

  const closeVisibilityMenu = () => {
    setVisibilityAnchorEl(null);
  };

  const toggleAxisVisiblity = () => {
    setShowAxis(!showAxis);
    viewer.setAxisVisiblity(!showAxis);
  };

  const togglePhotoshotVisiblity = () => {
    setShowPhotoshot(!showPhotoshot);
    viewer.setPhotoshotVisible(!showPhotoshot);
  };

  // const disabledToggleAxis = () => {
  //   return whilePointCloudLoading;
  // }

  const toggleShowPointcloud = () => {
    setShowPointCloud(!showPointCloud);
    viewer.setPointCloudVisibility(!showPointCloud);
  };

  const toggleProjectState = () => {
    // hideAllMenus();
    setOpenProjectState(!openProjectState);
  };

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [imageInfo, setImageInfo] = useState<{ name: string; src: string }>({
    name: "",
    src: "",
  });

  useEffect(() => {
    const handlePhotoshotClick = (e: any) => {
      const { photoName } = e.detail;
      let hostName = config.serverHost.includes("localhost")
        ? "http://localhost:9090/quick3d"
        : config.serverHost;
      const imageUrl = `${hostName}/project_${props.projectDetail.id}/${photoName}`;
      setImageInfo({ name: photoName, src: imageUrl });
      setOpenImageDialog(true);
    };

    window.addEventListener("photoshot-clicked", handlePhotoshotClick);
    return () => {
      window.removeEventListener("photoshot-clicked", handlePhotoshotClick);
    };
  }, []);

  return (
    <>
      <Q3DIconButton
        title={t("SHOW_HIDE")}
        titleType="tooltip"
        onClick={(e) => {
          openVisibilityMenu(e);
        }}
        icon={
          <SvgIcon>
            <path d={toolBoxIcon_1} fill={BLACK} />
            <path d={toolBoxIcon_2} fill={WHITE} />
            <path d={toolBoxIcon_3} fill={WHITE} />
          </SvgIcon>
        }
        height={btnSize}
        width={btnSize}
        disabled={detailTab === DETAIL_TAB.PHOTO}
      />
      <Menu
        id="simple-menu"
        keepMounted
        anchorEl={visibilityAnchorEl}
        open={Boolean(visibilityAnchorEl)}
        onClose={closeVisibilityMenu}
        style={{ borderRadius: "0px" }}
        // PaperProps={{ style: { ...customBackground, ...customColor } }}
      >
        <MenuItem
          value="focusBelow"
          className="point-view4"
          // disabled={disabledToggleAxis()}
          onClick={toggleShowPointcloud}
        >
          <Tooltip
            title={
              <span className="point-view4-tool-tip">
                {t("DISPLAY_POINT_GROUP")}
              </span>
            }
            arrow
            placement="left"
            disableInteractive
          >
            <span>
              <SvgIcon>
                <path d={toolBoxIcon_1} fill={BLACK} />
                <path d={toolBoxIcon_2} fill={WHITE} />
                <path d={toolBoxIcon_3} fill={WHITE} />
              </SvgIcon>
            </span>
          </Tooltip>
        </MenuItem>
        <MenuItem
          value="focusBelow"
          className="point-view4"
          // disabled={disabledToggleAxis()}
          onClick={toggleAxisVisiblity}
        >
          <Tooltip
            title={
              <span className="point-view4-tool-tip">{t("DISPLAY_AXIS")}</span>
            }
            arrow
            placement="left"
            disableInteractive
          >
            <span>
              <ToolIcon
                imagePath={CoordinateIcon}
                color={
                  // disabledToggleAxis() || !showAxis ? "gray" : customColor.color
                  customColor.color
                }
              />
            </span>
          </Tooltip>
        </MenuItem>
        <MenuItem onClick={toggleProjectState}>
          <Tooltip
            title={
              <span className="point-view4-tool-tip">
                {t("DISPLAY_STATUS")}
              </span>
            }
            arrow
            placement="left"
            disableInteractive
          >
            <FactCheckIcon
              sx={{
                color: customColor.color,
              }}
            />
          </Tooltip>
        </MenuItem>
        <MenuItem onClick={togglePhotoshotVisiblity}>
          <Tooltip
            title={
              <span className="point-view4-tool-tip">
                {t("DISPLAY_PHOTOSHOT")}
              </span>
            }
            arrow
            placement="left"
            disableInteractive
          >
            <span>
              <RouteIcon
                style={{
                  transform: "rotate(45deg)",
                }}
              />
            </span>
          </Tooltip>
        </MenuItem>
      </Menu>
      {showPhotoshot && (
        <ImageViewerDialog
          open={openImageDialog}
          setOpen={setOpenImageDialog}
          imageSrc={imageInfo.src}
          imageName={imageInfo.name}
        />
      )}
    </>
  );
};
